import 'jquery';

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("popup-form");
  const closeBtn = popup.querySelector(".popup-close");
  const popupBody = popup.querySelector(".popup-body");

  document.querySelectorAll(".popup-trigger").forEach(btn => {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      
      //clear contet
      popupBody.innerHTML = "";

      // show popup
      popup.classList.remove("popup-hidden");

      // Load HubSpot form dynamically
      const formId = btn.getAttribute("data-form-id");
      if (window.hbspt) {
        hbspt.forms.create({
          portalId: "46385815",
          formId: formId,
          target: "#popup-form .popup-body",
          region: "na1"
        });
      } else {
        
        const script = document.createElement("script");
        script.src = "//js.hsforms.net/forms/embed/v2.js";
        script.charset = "utf-8";
        script.onload = () => {
          hbspt.forms.create({
            portalId: "46385815",
            formId: formId,
            target: "#popup-form .popup-body",
            region: "na1"
          });
        };
        document.body.appendChild(script);
      }
    });
  });

  closeBtn.addEventListener("click", function() {
    popup.classList.add("popup-hidden");
    popupBody.innerHTML = ""; // clean on close
  });

  popup.addEventListener("click", function(e) {
    if (e.target === popup) {
      popup.classList.add("popup-hidden");
      popupBody.innerHTML = ""; // clean on close
    }
  });
});
